import { styled } from "styled-system/jsx";

export const ActivityFeedButton = styled("button", {
  base: {
    fontSize: "2xs",
    lineHeight: "3xs",
    fontWeight: "semiBold",
    letterSpacing: "normal",
    fontFamily: "body",
    fontVariantNumeric: "lining-nums tabular-nums",
    color: "text.mid",
    display: "flex",
    alignItems: "center",
    gap: "100",
    cursor: "pointer",
    width: "max-content",
  },
  variants: {
    visual: {
      primary: {},
      warning: {
        color: "text.warning.mid",
      },
      error: {
        color: "text.error.mid",
      },
      success: {
        color: "text.success.mid",
      },
      highlight: {
        color: "text.highlight.mid",
      },
      "accent.magenta": {
        color: "text.accent.magenta.mid",
      },
      "accent.blue": {
        color: "text.accent.blue.mid",
      },
      "accent.purple": {
        color: "text.accent.purple.mid",
      },
    },
  },
});
